import "../../styles/driver_modal.css";


export default function CarDeleteModal({ driver, onClose, onConfirm }) {
  if (!driver) return null;

  return (
    <div className="modalOverlay" onClick={onClose}>
      <div
        className="modalCard modalDanger"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="modalDangerTitle">Supprimer le chauffeur</h3>

        <p className="modalDangerText">
          Êtes-vous sûr de vouloir supprimer
          <strong> {driver.user?.firstName} {driver.user?.lastName}</strong> ?
        </p>

        <p className="modalDangerWarning">
          Cette action est irréversible.
        </p>

        <div className="modalActions">
          <button className="btnGhost" onClick={onClose}>
            Annuler
          </button>

          <button
            className="btnDanger"
            onClick={() => onConfirm(driver.id)}
          >
            Supprimer
          </button>
        </div>
      </div>
    </div>
  );
}
